import { Pipe, PipeTransform } from "@angular/core";
import { Helper } from "@helpers/functions";
import { getLocaleArray } from "@helpers/utils";

@Pipe({
	name: "locale_effective_leverage",
	standalone: false
})
export class EffectiveLeverageTokenPipe implements PipeTransform {
	// if selected language it DE then use , otherwise use .
	transform(value: string, precision: number = 1): string {
		value = Math.abs(+value).toString();
		if (!value) {
			return "";
		}
		const locale = getLocaleArray(Helper.getLanguage());

		return this.adjustLocale(value, locale[0], precision);
	}

	private adjustLocale(value: string, locale: string, precision: number): string {
		value = value.substring(0, precision + 2);
		return locale === "de-DE" ? value.replace(/[.,]/, ",") : value.replace(/[.,]/, ".");
	}
}
